import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { School } from "../types/exames";

const defaultValues = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface SchoolZusProps {
  schools: {
    data: School[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedSchool: School | undefined;
  selectedSchoolId: number | undefined;
  setSchools: (schools: { data: School[]; pagination: any }) => void;
  setSelectedSchool: (school: School) => void;
  setSelectedSchoolId: (schoolId: number | undefined) => void;
  resetState: () => void;
  removeSchool: (id: number) => void;
  updateSchool: (school: School) => void;
}

const useSchoolStore = create<SchoolZusProps>()(
  persist(
    (set, get) => ({
      schools: defaultValues,
      selectedSchool: undefined,
      selectedSchoolId: undefined,
      setSchools: (schoolsResponse) => {
        set({
          schools: {
            data: schoolsResponse.data || [],
            pagination: schoolsResponse.pagination || defaultValues.pagination
          }
        });
      },
      setSelectedSchool: (school: School) => {
        set({
          selectedSchool: school
        });
      },
      setSelectedSchoolId: (schoolId: number | undefined) => {
        set({
          selectedSchoolId: schoolId
        });
      },
      resetState: () => {
        set({
          schools: defaultValues,
          selectedSchool: undefined,
          selectedSchoolId: undefined
        });
      },
      removeSchool: (id: number) => {
        const { schools } = get();
        const newState = {
          ...schools,
          data: schools.data.filter((item) => item.id !== id)
        };
        set({
          schools: newState
        });
      },
      updateSchool: (school: School) => {
        const { schools } = get();
        const newState = {
          ...schools,
          data: schools.data.map((item) =>
            school.id === item.id ? school : item
          )
        };
        set({
          schools: newState,
          selectedSchool: school
        });
      }
    }),
    {
      name: "schools",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useSchoolStore;
